import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import kitchenDefault from '~/assets/img/empty-kitchener.svg'
import kitchenRed from '~/assets/img/empty-kitchener-red.svg'
import hookahIconDefault from '~/assets/img/empty-hookah.svg'
import hookahIconRed from '~/assets/img/empty-hookah-red.svg'
import waiterIconDefault from '~/assets/img/empty-waiter.svg'
import waiterIconRed from '~/assets/img/empty-waiter-red.svg'
import barmenIconDefault from '~/assets/img/empty-barmen.svg'
import barmenIconRed from '~/assets/img/empty-barmen-red.svg'
import baristaIconDefault from '~/assets/img/empty-barista.svg'
import baristaIconRed from '~/assets/img/empty-barista-red.svg'
import sommelierIconDefault from '~/assets/img/empty-sommelier.svg'
import sommelierIconRed from '~/assets/img/empty-sommelier-red.svg'
import teamIconDefault from '~/assets/img/empty-team.svg'
import teamIconRed from '~/assets/img/empty-team-red.svg'
import { useThemeModel } from '@entities/theme'


export default /*#__PURE__*/_defineComponent({
  __name: 'TipsProfile',
  props: {
  data: {
    type: Object,
    required: true,
    default: () => ({
      name: ''
    })
  }
},
  setup(__props) {

const props = __props

const themeModel = useThemeModel()



// Маппинг иконок
/* eslint quote-props: ['error', 'consistent'] */
const iconMap = {
  'Кальянщик': { default: hookahIconDefault, red: hookahIconRed },
  'Кухня': { default: kitchenDefault, red: kitchenRed },
  'Официант': { default: waiterIconDefault, red: waiterIconRed },
  'Бармен': { default: barmenIconDefault, red: barmenIconRed },
  'Бариста': { default: baristaIconDefault, red: baristaIconRed },
  'Сомелье': { default: sommelierIconDefault, red: sommelierIconRed },
  'Команда заведения': { default: teamIconDefault, red: teamIconRed }
}

// Определяем нужную иконку в зависимости от темы
const iconSrc = computed(() => {
  const theme = themeModel.theme.toLowerCase()
  const isNovikov = theme === 'novikov'
  return iconMap[props.data.label as keyof typeof iconMap]?.[isNovikov ? 'red' : 'default'] || null
})

return { __sfc: true,themeModel, props, iconMap, iconSrc }
}

})